import { UserAssignmentStatus } from '@insync-students-constants/assignmentStatus';
import { EvidenceTypesEnum } from '@insync-students-constants/evidenceTypes';
export class Assignment {
  assignedAt!: Date;
  contentId!: string;
  contextId!: string;
  dueDate!: Date;
  evidenceType!: EvidenceTypesEnum;
  id!: string;
  instructions!: string;
  resourceId!: string;
  status!: UserAssignmentStatus;
  title!: string;
  userAssignmentId!: string;
  userStatus?: UserAssignmentStatus;
  parentId?: string;
  parentType?: string;
  getAssignmentUrl() {
    return `/assignment/${this.id}`;
  }
  constructor(data: Partial<Assignment> = {}) {
    Object.assign(this, data);
  }
}